export enum Steps {
  VALIDATE_DOCUMENT = 'validate-document',
  DOCUMENT_PREVIEW = 'document-preview',
  VALIDATING_DOCUMENT = 'validating-document',
  DOCUMENT_ERROR = 'document-error',
  IDENTITY_SUCCESS = 'identity-success',
  CPF_IN_USE = 'cpf-in-use',
  REMOVAL_CPF_EMAIL = 'removal-cpf-email',
  IDENTITY_ERROR = 'identity-error',
}
